import APIClient from '../../../common/APIClient';
import { toggleShowAlert, displayError, SUCCESS_ALERT, MAX_ITEMS_IN_PAGE } from '../commonActions';

const FETCH_ALL_ACTIVITIES = 'FETCH_ALL_ACTIVITIES';
const ACTIVITY_FILTER = 'ACTIVITY_FILTER';
const CLEAR_ACTIVITIES = 'CLEAR_ACTIVITIES';
const SET_ACTIVITY_FIELD_CHANGE = 'SET_ACTIVITY_FIELD_CHANGE';
const RESET_ACTIVITY = 'RESET_ACTIVITY';
const SET_ACTIVITY = 'SET_ACTIVITY';

export const SET_ACTIVITIES_PAGINATION = 'SET_ACTIVITIES_PAGINATION';
export const RESET_ACTIVITIES_PAGINATION = 'RESET_ACTIVITIES_PAGINATION';

export const ACTIVE = 1;
export const INACTIVE = 0;

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const fetchActivities = (filters = null) => {
  return (dispatch, getState) => {
    client().get(
      'tasks-template/activities/list', {
        params: filters
      }
    ).then(json => {  
      const result = json.data;
      if (result) {
        let activities = result.data;
        if (!activities.length) {
          activities = null;
        }
        else {
          let numItems = activities.length;
          let min = getState().activities.min;
          let max = numItems < MAX_ITEMS_IN_PAGE ? numItems : getState().activities.max;
          
          const totalPages = Math.ceil(numItems / MAX_ITEMS_IN_PAGE);
          
          dispatch({type: SET_ACTIVITIES_PAGINATION, numItems, min, max, totalPages});
        }

        dispatch({type: FETCH_ALL_ACTIVITIES, activities});
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const filterActivities = (activityFilter) => {
  return (dispatch) => {
    dispatch({type: ACTIVITY_FILTER, activityFilter});
  }
}

export const clearActivities = () => {
  return (dispatch) => {
    dispatch({type: CLEAR_ACTIVITIES});
  }
}

export const enableActivity = (id) => {
  return (dispatch) => {
    client().get(
      'tasks-template/activities/enable', {
        params: {
          id
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        dispatch(toggleShowAlert(true, SUCCESS_ALERT, 'Activity has been successfully enabled.'));
        dispatch(fetchActivities({active: INACTIVE}));
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const disableActivity = (id) => {
  return (dispatch) => {
    client().get(
      'tasks-template/activities/disable', {
        params: {
          id
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        dispatch(toggleShowAlert(true, SUCCESS_ALERT, 'Activity has been successfully disabled.'));
        dispatch(fetchActivities({active: ACTIVE}));
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const handleInputChange = (e) => {
  return (dispatch) => {
    const id = e.target.id;
  
    const value = {
      [id]: e.target.value
    }

    dispatch({type: SET_ACTIVITY_FIELD_CHANGE, value})
  }
}

export const upsertActivity = (action = null, callback = null) => {
  return (dispatch, getState) => {
    const activityObj = getState().activities.activity;

    if (typeof(activityObj.active) === 'undefined') {
      activityObj.active = 1;
    }
    
    let endpoint = 'tasks-template/activities/create';
    let message = 'Activity has been successfully created.';

    if (action === 'UPDATE_ACTIVITY') {
      endpoint = 'tasks-template/activities/update';
      message = 'Activity has been successfully updated.';
    }

    client().post(
      endpoint, 
      activityObj
    ).then(json => {
      const result = json.data;
      if (result) {
        dispatch(toggleShowAlert(true, SUCCESS_ALERT, message));
        if (callback) {
          callback();
        }
      }
    }).catch(error => {
      dispatch(displayError(error))
    })
  }
}

export const resetActivity = () => {
  return (dispatch) => {
    dispatch({type: RESET_ACTIVITY});
  }
}

export const getActivity = (activityCode) => {
  return (dispatch) => {
    client().get(
      'tasks-template/activities/get', {
        params: {
          activity_code: activityCode
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        const activity = result.data;
        dispatch({type: SET_ACTIVITY, activity});
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}